import type { IErrorAuth } from '@/shared/common/types/authError.type';

export const ErrorsAuth: IErrorAuth = {
  CUSTOMER_ACCOUNT_NEED_ATTENTION:
    'Tu cuenta requiere atención, te sugerimos contactarte con nuestro servicio al cliente contacto@global66.com',
  CUSTOMER_ACCOUNT_EMERGENCY_BLOCKED:
    'Tu cuenta ha sido bloqueada por seguridad. Por favor, contacta a soporte.',
  AUTHENTICATION_FAILED_PERMANENTLY_BLOCKED:
    'Cuenta bloqueada permanentemente, Por favor, contacta a soporte.',
  NOT_FOUND: 'Correo o contraseña incorrectos',
  UNAUTHORIZED:
    'No pudimos acceder a tu cuenta. Intenta Recuperar contraseña e ingresar de nuevo. Si sigues teniendo dificultades, un asesor puede ayudarte.',
  REQUEST_PARAMETER_NOT_VALID:
    'La contraseña debe tener entre 6 y 100 caracteres',
  CUSTOMER_ALREADY_EXISTS: 'El correo de la empresa ya está en uso',
  COMPANY_ALREADY_EXISTS: 'El nombre de la empresa ya está en uso',
  AUTHENTICATION_FAILED_ATTEMPT_ONE:
    'El correo o la contraseña ingresados son incorrectos. Te queda 1 intento más antes de que se apliquen restricciones.',
  AUTHENTICATION_FAILED_ATTEMPT_TWO:
    'El correo o la contraseña ingresados son incorrectos nuevamente. Este es tu último intento antes de que se apliquen restricciones.',
  AUTHENTICATION_FAILED_ATTEMPT_THREE:
    'Has alcanzado el límite de intentos fallidos. Por favor, revisa tu correo y contraseña e intenta nuevamente después del tiempo indicado.',
  AUTHENTICATION_FAILED_BLOCKED_LEVEL_1:
    'Tu cuenta ha sido bloqueada temporalmente debido a múltiples intentos fallidos. Intenta nuevamente en 5 minutos.',
  AUTHENTICATION_FAILED_BLOCKED_LEVEL_2:
    'Tu cuenta ha sido bloqueada temporalmente debido a múltiples intentos fallidos. Intenta nuevamente en 1 hora.',
  AUTHENTICATION_FAILED_BLOCKED_LEVEL_3:
    'Tu cuenta ha sido bloqueada permanentemente por motivos de seguridad. Por favor, contacta al equipo de soporte para desbloquearla.',
  CUSTOMER_NOT_FOUND: 'No se ha encontrado el usuario',
  ACCOUNT_IS_NOT_ACTIVE:
    'Tu cuenta ha sido bloqueada por seguridad. Por favor, contacta a soporte.',
  INTERNAL_SERVER_ERROR: 'Ocurrió un error inesperado, inténtalo más tarde',
  DEFAULT: 'Ha ocurrido un error al guardar los datos',
  GENERIC_ERROR:
    'Ha ocurrido un error inesperado. Por favor, intenta nuevamente.',
  EMAIL_NOT_CONFIRMED:
    'Aún debes validar tu email para iniciar sesión. Te enviamos un correo de activación al momento de tu registro',
  EMAIL_ALREADY_EXISTS: 'El correo electrónico ya está en uso',
  USER_DISABLED: 'Tu cuenta está desactivada. Contacta al administrador para habilitar el acceso.'
} as const;
